import React from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { signOut } from "firebase/auth";
import { auth } from "../../firebase";

export default function AdminLayout({ children }) {
  const location = useLocation();
  const navigate = useNavigate();

  const handleLogout = async () => {
    await signOut(auth);
    navigate("/login");
  };

  const tabs = [
    { label: "Overview", path: "/admin" },
    { label: "Bars to call", path: "/admin/outreach" },
    { label: "Reports", path: "/admin/reports" },
    { label: "Claimed bars", path: "/admin/claimed" },
    { label: "Demo bar", path: "/admin/demo" },
    { label: "Add a Bar", path: "/admin/add-bar" },
    { label: "Gambling States", path: "/admin/gambling-states" },
    { label: "Pills by state", path: "/admin/pills" },
    { label: "Load Bars", path: "/admin/import" },
    { label: "National bars", path: "/admin/national" },
    { label: "Sign-ups", path: "/admin/signups" },
    { label: "Posts", path: "/admin/posts" },
  ];

  return (
    <div style={{ minHeight: "100vh", background: "#0B0B12" }}>
      <div
        style={{
          background: "linear-gradient(90deg, #6D28D9, #A855F7)",
          padding: "14px 24px",
          display: "flex",
          alignItems: "center",
          gap: "14px",
        }}
      >
        <span
          style={{
            background: "rgba(0,0,0,0.25)",
            color: "#fff",
            padding: "4px 12px",
            borderRadius: "20px",
            fontSize: "15px",
            fontWeight: 700,
            letterSpacing: "0.08em",
          }}
        >
          ADMIN MODE
        </span>
        <span style={{ color: "#fff", fontSize: "14px", opacity: 0.9 }}>
          You're managing Bar Fun Finder's backend — regular bar owners never see this.
        </span>
        <button
          onClick={handleLogout}
          style={{
            marginLeft: "auto",
            background: "rgba(0,0,0,0.25)",
            border: "1px solid rgba(255,255,255,0.3)",
            padding: "8px 16px",
            borderRadius: "8px",
            color: "#fff",
            fontSize: "16px",
            fontWeight: 600,
            cursor: "pointer",
          }}
        >
          Log Out
        </button>
      </div>

      <div
        style={{
          display: "flex",
          gap: "6px",
          padding: "14px 24px 0",
          borderBottom: "1px solid rgba(255,255,255,0.08)",
        }}
      >
        {tabs.map((tab) => {
          const isActive = location.pathname === tab.path;
          return (
            <Link
              key={tab.path}
              to={tab.path}
              style={{
                textDecoration: "none",
                color: isActive ? "#fff" : "#B8B0C8",
                padding: "10px 18px",
                fontSize: "14px",
                fontWeight: isActive ? 700 : 500,
                borderBottom: isActive ? "2px solid #A855F7" : "2px solid transparent",
              }}
            >
              {tab.label}
            </Link>
          );
        })}
      </div>

      <div style={{ padding: "24px" }}>{children}</div>
    </div>
  );
}
